const Sayfa = resolve => {
    require.ensure(['../views/apps/sayfa/Sayfa'], () => {
        resolve(require('../views/apps/sayfa/Sayfa'))
    })
};
const SayfaDetay = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaDetay'], () => {
        resolve(require('../views/apps/sayfa/SayfaDetay'))
    })
}
const SayfaTanimla = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaTanimla'], () => {
        resolve(require('../views/apps/sayfa/SayfaTanimla'))
    })
};
const SayfaListesi = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaListesi'], () => {
        resolve(require('../views/apps/sayfa/SayfaListesi'))
    })
};
const SayfaGuncelle = resolve => {
    require.ensure(['../views/apps/sayfa/SayfaGuncelle'], () => {
        resolve(require('../views/apps/sayfa/SayfaGuncelle'))
    })
};

import Vue from 'vue'
Vue.component('SayfaDetay', SayfaDetay);
Vue.component('SayfaTanimla', SayfaTanimla);
Vue.component('SayfaListesi', SayfaListesi);
Vue.component('sayfaguncelle', SayfaGuncelle);
import layouts from '../layout'

export default {
    path: '/sayfa',
    name: 'sayfa',
    component: Sayfa,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'sayfadetay',
            component: SayfaDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
